export const DashedLine = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 150 1"
      width="100%"
      height="1"
      preserveAspectRatio="none"
    >
      <path stroke="#919090" strokeDasharray="4 4" d="M0 .5h150" />
    </svg>
  )
}
